import React, { useEffect, useState, useContext } from "react";
import { Input } from "design-react-kit";
import ModalComponent from "../../Components/ModalComponent";
import Repo from "../../Utility/Repo";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import { useParams } from 'react-router-dom';
import Pagination from "../../Components/Pagination";
import TableCellWithTooltip  from "../../Components/TableCellWithTooltip";




function EditFondo(props) {
  const apiToken = useContext(TokenContext);
  const [isOpenUpd, toggleModalUpd] = useState(false);
  const [isOpenAdd, toggleModalAdd] = useState(false);
  const [validation, setValidation] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isDisabled, setIsDisabled] = useState(true);
  const { id } = useParams();
  const [titoloPagina,setTitoloPagina] =  useState("");
  const [fondiList, setFondiList] = useState([]);
  const [fondiListTemp, setFondiListTemp] = useState();


const [fondo, setFondo] = useState({
    id: null,
    descrizione: "",
    capitolo: "",
    articolo: "",
    stanziato: 0,
    impegnato: 0,
    variazioni: 0,
    dataFreeze: new Date().toISOString(),
  });



  useEffect(() => {
    
    if (id != null) {
        setLoading(false);
        setTitoloPagina("Modifica fondo");
      Repo.getFondoOperator(apiToken, id)
        .then((response) => {
          setFondo(response.data);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });

        Repo.getFondiStoricoListaOperator(apiToken,id)
        .then((response) => {
          setFondiListTemp(response.data);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });

    }else{
        setTitoloPagina("Nuovo fondo");
        setIsDisabled(false);
    }
  }, []);





  const validateFondo = () => {
    setValidation(true); // Imposta il flag di validazione su true
    let passedValidation = true; // Inizializza la variabile per tenere traccia dello stato della validazione
  
    // Verifica che tutti i campi richiesti del fondo siano compilati
    if (!fondo.descrizione || !fondo.capitolo || !fondo.articolo || fondo.stanziato === null || fondo.impegnato === null) {
      passedValidation = false;
    }
  
    return passedValidation;
  };


  const fondoEditValidation = () => {
    if (validateFondo()) {
        toggleModalUpd(!isOpenUpd);
      }
  };


  const fondoAddValidation = () => {
    if (validateFondo()) {
      toggleModalAdd(!isOpenAdd);
    }
  };



  const updateFondoAPI = () => {
    Repo.updateFondoOperator(apiToken, JSON.stringify(fondo))
      .then((response) => {
        if (response.status == 200) {
          window.location.href = props.subfolder + "/rendicontazione";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };




  const addFondoAPI = () => {
    Repo.addFondoOperator(apiToken, JSON.stringify(fondo))
      .then((response) => {
        if (response.status == 200) {
          window.location.href = props.subfolder + "/rendicontazione";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };


  return (
    <div>
      <h1>{titoloPagina}</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p> </p>
          </div>
		  

          <div className="row">
  <div className="col-lg-4">
    <Input
      id="descrizione"
      disabled={isDisabled}
      label="Descrizione"
      type="text"
      name="descrizione"
      value={fondo ? fondo.descrizione : ""}
      onChange={(e) =>
        setFondo({ ...fondo, descrizione: e.target.value })
      }
    />
  </div>
  <div className="col-lg-4">
    <Input
      id="capitolo"
      disabled={isDisabled}
      label="Capitolo"
      type="text"
      name="capitolo"
      value={fondo ? fondo.capitolo : ""}
      onChange={(e) =>
        setFondo({ ...fondo, capitolo: e.target.value })
      }
    />
  </div>
  <div className="col-lg-4">
    <Input
      id="articolo"
      disabled={isDisabled}
      label="Articolo"
      type="text"
      name="articolo"
      value={fondo ? fondo.articolo : ""}
      onChange={(e) =>
        setFondo({ ...fondo, articolo: e.target.value })
      }
    />
  </div>
</div>
<div className="row mt-2">
  <div className="col-lg-4">
    <Input
      id="stanziato"
      disabled={isDisabled}
      label="Stanziato"
      type="number"
      name="stanziato"
      value={fondo ? fondo.stanziato.toString() : ""}
      onChange={(e) =>
        setFondo({ ...fondo, stanziato: parseFloat(e.target.value) })
      }
    />
  </div>
  <div className="col-lg-4">
    <Input
      id="impegnato"
      disabled={isDisabled}
      label="Impegnato"
      type="number"
      name="impegnato"
      value={fondo ? fondo.impegnato.toString() : ""}
      onChange={(e) =>
        setFondo({ ...fondo, impegnato: parseFloat(e.target.value) })
      }
    />
  </div>
  <div className="col-lg-4">
    <Input
      id="variazioni"
      disabled={isDisabled}
      label="Variazioni"
      type="number"
      name="variazioni"
      value={fondo ? fondo.variazioni.toString() : ""}
      onChange={(e) =>
        setFondo({ ...fondo, variazioni: parseFloat(e.target.value) })
      }
    />
  </div>
</div>
{id ? (
<div className="row mt-2">
  <div className="col-lg-6">
    <Input
      id="dataFreeze"
      disabled={isDisabled}
      label="Data Freeze"
      type="text"
      name="dataFreeze"
      value={fondo ? new Date(fondo.dataFreeze).toLocaleDateString() : ""}
      onChange={(e) =>
        setFondo({ ...fondo, dataFreeze: new Date(e.target.value) })
      }
    />
  </div>
</div>) : <></>}


{isDisabled ? (
  <div className="row my-2">
    <div className="col-lg-12 text-right">
      <button
        type="button"
        className="btn btn-outline-primary"
        data-toggle="tooltip"
        data-placement="top"
        onClick={() => setIsDisabled(!isDisabled)}
        title="Modifica"
      >
        Modifica
      </button>
    </div>
  </div>
) : (
  <div className="row my-2">
    <div className="col-lg-10 text-right">
      <button
        type="button"
        className="btn btn-outline-info"
        data-toggle="tooltip"
        data-placement="top"
        onClick={() => setIsDisabled(!isDisabled)}
        title="Indietro"
      >
        Indietro
      </button>
    </div>
    <div className="col-lg-2 text-right">
      <button
        type="button"
        className="btn btn-primary"
        data-toggle="tooltip"
        data-placement="top"
        onClick={() => {
            if (id) {
              fondoEditValidation();
            } else {
              fondoAddValidation();
            }
          }}
        title="Conferma"
      >
        Conferma
      </button>
    </div>
  </div>
)}
<hr/>
{id ? (
<div>
<h3>Storico - {fondo ? fondo.descrizione : ""}</h3>
<table className="table table-hover">
          <thead>
            <tr>
     
                <th>Data movimento</th>

              <th scope="col-2">Ex Bilancio</th>
      
              <th scope="col">Stanziato</th>
              <th scope="col">Impegnato</th>
              <th scope="col">Disponibilità</th>
              <th scope="col">Data Freeze</th>
             
              
              <th scope="col">Variazione</th>
              <th scope="col">Data Trasferimento</th>
              <th scope="col">Note</th>
            </tr>
          </thead>
          <tbody>
            {fondiList &&
              fondiList.length > 0 &&
              fondiList.map((x, index) => (
                <React.Fragment key={index}>
                  <tr key={index}>

                  
                  <td>{x.dataInsert}</td>
      
                    <td>Cap. {x.capitolo} Art. {x.articolo}</td>
                    <td>
                      {x.stanziato.toLocaleString("it-IT", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                    <td>
                      {x.impegnato.toLocaleString("it-IT", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                    <td>
                      {(x.stanziato - x.impegnato).toLocaleString("it-IT", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                    <td>{x.dataFreeze}</td>
                   

                    <td>
                      {x.variazioni.toLocaleString("it-IT", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </td>
                    <td>{x.dataTransferimento}</td>
                   <TableCellWithTooltip value={x.motivazione} id={x.id} />
                    
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        </table>

        {fondiListTemp && (
          <Pagination
            items={fondiListTemp}
            setCurrentItems={setFondiList}
            itemsPerPage={10}
          ></Pagination>
        )}
      </div>) : (<></>)}
        
     
      <ModalComponent
        toggleModalUpd={toggleModalUpd}
        isOpen={isOpenUpd}
        header="Modifica fondo"
        body="Confermi di voler modificare i valori del fondo?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => updateFondoAPI()}
      ></ModalComponent>

      <ModalComponent
        toggleModalUpd={toggleModalAdd}
        isOpen={isOpenAdd}
        header="Aggiungi fondo"
        body="Confermi di voler aggiungere i valori del fondo?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => addFondoAPI()}
      ></ModalComponent>



      {!loading && <Loader></Loader>}
    </div>
  );
}

export default EditFondo;
